var map = {
	"./ic_arbitrum_24.svg": 479,
	"./ic_avalanche_24.svg": 480,
	"./ic_bal_24.svg": 481,
	"./ic_btc_24.svg": 482,
	"./ic_busd_24.svg": 483,
	"./ic_crv_24.svg": 484,
	"./ic_dai_24.svg": 485,
	"./ic_eth_24.svg": 486,
	"./ic_frax_24.svg": 487,
	"./ic_fxs_24.svg": 488,
	"./ic_kcc_24.svg": 235,
	"./ic_kcs_24.svg": 489,
	"./ic_klp_24.svg": 236,
	"./ic_link_24.svg": 490,
	"./ic_mim_24.svg": 491,
	"./ic_ppusd_24.svg": 492,
	"./ic_tcr_24.svg": 493,
	"./ic_tether_24.svg": 494,
	"./ic_uni_24.svg": 495,
	"./ic_usdc.e_24.svg": 496,
	"./ic_usdc_24.svg": 497,
	"./ic_usdt_24.svg": 498,
	"./ic_wallet_24.svg": 194,
	"./ic_weth_24.svg": 499,
	"./ic_wkcs_24.svg": 500,
	"./ic_xkcs_24.svg": 501,
	"./ic_xusdt_24.svg": 502
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 790;